import React from 'react';
import { Info } from 'lucide-react';

import { Button } from '@epoch-ui/components/Button';

interface TimeChangeWarningBannerProps {
  onClick: () => void;
}

export const TimeChangeWarningBanner = ({
  onClick
}: TimeChangeWarningBannerProps): React.ReactElement => {
  return (
    <div className="tw-mt-2 tw-flex tw-items-center tw-gap-1 tw-text-yellow-warning">
      <Info className="tw-h-4 tw-w-4 tw-flex-shrink-0" />
      <div className="tw-text-xs tw-leading-4">
        Timing of scheduled features will be updated.{' '}
        <Button
          variant="link"
          size="none"
          className="tw-p-0 tw-text-xs tw-font-normal"
          onClick={onClick}
        >
          See details
        </Button>
      </div>
    </div>
  );
};
